module.exports = __webpack_public_path__ + "web/img/icon_ar.36d49e62.png";